import { IOreOfferResponse } from '../../entities/campaigns/types';
import OreOffer from '../../entities/campaigns/offers/OreOffer';
import { IDiscounts } from '../../entities/product/types';

export default class OreOfferFactory {

  static create(oreOffer: IOreOfferResponse, discounts?: IDiscounts): OreOffer {
    return new OreOffer(
      parseInt(oreOffer.id),
      parseInt(oreOffer.offerId),
      oreOffer.optionName,
      oreOffer.products,
      oreOffer.saveDesk,
      oreOffer.p2p,
      oreOffer.contractDuration,
      oreOffer.upsell,
      oreOffer.featuredPackages,
      oreOffer.unfeaturedPackages,
      discounts?.greenVoucherDiscount ?? 0,
      discounts?.ebillDiscount ?? 0
    );
  }

}
